import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { PositionsStateType } from "../reducer/positions.reducer"
const state = (state: RootState) => state.positionsStore as PositionsStateType

export const selectPositions = createDraftSafeSelector(state, (store) => store.positions)
export const selectPositionsLoaded = createDraftSafeSelector(state, (store) => store.loaded)
export const selectGroupBy = createDraftSafeSelector(state, (store) => (store.groupBy));